module.exports = __webpack_public_path__ + "img/oie-produkt-detalj-large-02.jpg";